const PINBOX_CONFETTI_COLORS = [
  "#3978f6",
  "#ef7d32",
  "#8a61e8",
  "#f6bd3c",
  "#42b978",
];

export interface OnboardingConfettiOptions {
  angle: number;
  colors: string[];
  decay: number;
  drift: number;
  gravity: number;
  origin: { x: number; y: number };
  particleCount: number;
  scalar: number;
  spread: number;
  startVelocity: number;
  ticks: number;
}

export interface OnboardingConfettiBurst {
  delayMs: number;
  options: OnboardingConfettiOptions;
}

function createBurst(
  delayMs: number,
  side: "left" | "right",
  particleCount: number,
  startVelocity: number,
): OnboardingConfettiBurst {
  const isLeft = side === "left";

  return {
    delayMs,
    options: {
      angle: isLeft ? 58 : 122,
      colors: PINBOX_CONFETTI_COLORS,
      decay: 0.92,
      drift: isLeft ? 0.08 : -0.08,
      gravity: 0.78,
      origin: { x: isLeft ? 0.08 : 0.92, y: 0.78 },
      particleCount,
      scalar: 1.45,
      spread: 66,
      startVelocity,
      ticks: 320,
    },
  };
}

export function createOnboardingConfettiPlan(
  reduceMotion: boolean,
): OnboardingConfettiBurst[] {
  if (reduceMotion) return [];

  return [
    createBurst(0, "left", 42, 54),
    createBurst(0, "right", 42, 54),
    createBurst(360, "left", 32, 47),
    createBurst(360, "right", 32, 47),
    createBurst(820, "left", 24, 40),
    createBurst(1150, "right", 24, 40),
  ];
}
